import { render, staticRenderFns } from "./LibraryBreadcrumb.vue?vue&type=template&id=1b274881&"
import script from "./LibraryBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./LibraryBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports